module.exports = __webpack_public_path__ + "static/media/edit_white.01eeeaa4.svg";